import { render, staticRenderFns } from "./CreateUserPasswordModal.vue?vue&type=template&id=2787dda8&scoped=true&"
import script from "./CreateUserPasswordModal.vue?vue&type=script&lang=js&"
export * from "./CreateUserPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateUserPasswordModal.vue?vue&type=style&index=0&id=2787dda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2787dda8",
  null
  
)

export default component.exports